import {Component, input, output, ChangeDetectionStrategy} from '@angular/core';
import {RouterLink} from '@angular/router';
import {SeFeAlertModule} from 'se-fe-alert';
import {SeFeCardModule} from 'se-fe-card';
import {SeFeGridModule} from 'se-fe-grid';
import {SeFeSwitchModule} from 'se-fe-switch';
import {BundleSummary} from '../../../../../models/clare/bundle';

@Component({
  selector: 'product-bundling-card',
  imports: [RouterLink, SeFeCardModule, SeFeGridModule, SeFeSwitchModule, SeFeAlertModule],
  templateUrl: './product-bundling-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './product-bundling-card.component.scss',
})
export class ProductBundlingCardComponent {
  bundles = input<BundleSummary[]>([]);
  organizationId = input('');
  onlySoldInBundles = input(false);
  loading = input(false);
  isInBundle = input(false);

  onlySoldInBundlesChange = output<boolean>();

  action(checked: boolean): void {
    this.onlySoldInBundlesChange.emit(checked);
  }
}
